import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React, { Component } from 'react';
import Assessment from './components/Assessment';

import './components/result.css'

class App extends Component {
    constructor(props){
        super(props);
        
    }

    render() {
        return <Assessment />
    }
}
export default App;
 